import React, { useState, useEffect } from "react"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import { DialogActions, Divider, IconButton, Tab, Tabs } from "@material-ui/core"
import { X } from "lucide-react"
import useStyles from "./ModalStyles"

const Modal = ({
  children,
  title,
  modalOpen,
  onClose,
  cleanFunc,
  width,
  footer,
  tab,
  tabs,
  onChangeTab,
  infoContato,
  dadosContato,
  tipoModal,
  scrollable = true,
}) => {
  const classes = useStyles()
  const [isVisible, setIsVisible] = useState(false)
  const [isClosing, setIsClosing] = useState(false)

  useEffect(() => {
    if (modalOpen) {
      setIsVisible(true) // Abre o modal
    } else {
      setIsVisible(false) // Fecha o modal
    }
  }, [modalOpen])

  const handleClose = () => {
    setIsClosing(true)
    setTimeout(() => {
      setIsVisible(false)
      setIsClosing(false)
      onClose()
    }, 500)
    cleanFunc && cleanFunc()
  }

  // Define classes de cabeçalho e conteúdo conforme a variante
  const cClasseHeader = infoContato
    ? classes.header
    : tipoModal === "encaminhar"
      ? classes.tituloBranco
      : classes.titulo
  const cClasseConteudo = dadosContato
    ? classes.contentContato
    : tipoModal === "encaminhar"
      ? classes.contentBranco
      : scrollable
        ? classes.contentScrollable
        : classes.content

  const quantidadeDeFilhos = React.Children.count(dadosContato?.props.children?.props?.children)

  return (
    <>
      <Dialog
        open={isVisible}
        onClose={handleClose}
        disableEnforceFocus
        PaperProps={{
          className: `${modalOpen ? (isClosing ? classes.slideOut : classes.slideIn) : ""} ${classes.boxNovaConversa}`,
          style: {
            // HACK
            width: width ? width : "",
            display: isVisible ? "" : "none",
          },
        }}
      >
        {infoContato ? (
          <div className={cClasseHeader}>
            {infoContato}
            <IconButton className={classes.iconButton} onClick={handleClose}>
              <X strokeWidth={1.6} className={classes.iconX} size={"24px"} />
            </IconButton>
          </div>
        ) : (
          <div className={cClasseHeader}>
            {title}
            <IconButton className={classes.iconButton} onClick={handleClose}>
              <X strokeWidth={1.6} className={classes.iconX} size={"24px"} />
            </IconButton>
          </div>
        )}
        {tabs && (
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(_, v) => onChangeTab(v)}
            aria-label="disabled tabs example"
          >
            {tabs.map((tab, index) => (
              <Tab key={index} style={{ textTransform: "none" }} label={tab} />
            ))}
          </Tabs>
        )}
        {dadosContato ? (
          <>
            <Divider />
            <div className={`${quantidadeDeFilhos > 1 ? classes.dadosContatoGrande : classes.dadosContato}`}>
              {dadosContato}
            </div>
            <DialogContent className={classes.contentContato} dividers>
              {children}
            </DialogContent>
          </>
        ) : (
          <DialogContent className={cClasseConteudo} dividers>
            {children}
          </DialogContent>
        )}

        {footer && <DialogActions style={{ padding: 0, display: "block" }}>{footer}</DialogActions>}
      </Dialog>
    </>
  )
}
export default Modal
